export const FooterLinks = {
  PRIVACY_POLICY: '/privacy-policy',
  TERMS_AND_CONDITIONS: '/terms-and-conditions',
  REFUND_POLICY: '/refund-policy',
  CONTACT_US: '/contact-us',
  OUR_STORY: '/our-story',
};
